module.exports = __webpack_public_path__ + "img/1.fd4a3e02.png";